const _import = require('@/utils/import/_import_' + process.env.NODE_ENV)

const routes = [
  {
    path: '/services',
    component: _import('services/components/wrapper'),
    meta: {
      showInMenu: true,
      title: 'Услуги',
      menuKey: 'Services',
      roles: ['ROLE_ADMIN', 'ROLE_WAITER']
    },
    redirect: '/services',
    name: 'Services',
    children: [
      {
        path: '',
        name: 'Services',
        component: {
          template: '<div class="content-wrapper"><router-view></router-view></div>'
        },
        redirect: '/services',
        meta: {
          menuKey: 'Services',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        },
        children: [
          {
            path: '',
            name: 'Services.list',
            component: _import('services/components/services/list'),
            meta: {
              menuKey: 'Services',
              roles: ['ROLE_ADMIN', 'ROLE_WAITER']
            }
          },
          {
            path: 'create',
            name: 'Services.create',
            component: _import('services/components/services/create'),
            meta: {
              menuKey: 'Services',
              roles: ['ROLE_ADMIN', 'ROLE_WAITER']
            }
          },
          {
            path: ':id/edit',
            name: 'Services.edit',
            component: _import('services/components/services/edit'),
            meta: {
              menuKey: 'Services',
              roles: ['ROLE_ADMIN', 'ROLE_WAITER']
            }
          },
          {
            path: ':id/info',
            name: 'Services.info',
            component: _import('services/components/services/info'),
            meta: {
              menuKey: 'Services',
              roles: ['ROLE_ADMIN', 'ROLE_WAITER']
            }
          }
        ]
      },
      {
        path: 'categories',
        name: 'ServicesCategories',
        component: {
          template: '<div class="content-wrapper"><router-view></router-view></div>'
        },
        meta: {
          menuKey: 'Services',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        },
        children: [
          {
            path: '',
            name: 'ServicesCategories.list',
            component: _import('services/components/categories/list'),
            meta: {
              menuKey: 'Services',
              roles: ['ROLE_ADMIN', 'ROLE_WAITER']
            }
          },
          {
            path: 'create',
            name: 'ServicesCategories.create',
            component: _import('services/components/categories/create'),
            meta: {
              menuKey: 'Services',
              roles: ['ROLE_ADMIN', 'ROLE_WAITER']
            }
          },
          {
            path: ':id/edit',
            name: 'ServicesCategories.edit',
            component: _import('services/components/categories/edit'),
            meta: {
              menuKey: 'Services',
              roles: ['ROLE_ADMIN', 'ROLE_WAITER']
            }
          }
        ]
      }
    ]
  }
]

routes.forEach(route => {
  route.children.forEach(child => {
    child.meta.menuKey = 'Services'
  })
})

export default routes



// WEBPACK FOOTER //
// ./src/modules/services/routes.js